import state from './moduloEmailsState';
import mutations from './moduloEmailsMutations';
import * as actions from './moduloEmailsActions';
import * as getters from './moduloEmailsGetters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
